<template>
  <v-container fill-height>
    <v-row align="center">
      <v-col cols="12" offset-md="2" md="8" offset-sm="1" sm="10">
        <v-card class="elevation4">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>Регистрация</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form v-model="valid" ref="form">
              <v-text-field
                label="Ваш email"
                v-model="email"
                autofocus
                required
                id="email"
                :rules="[
                  validation.emailIsRequired,
                  validation.emailMustBeValid
                ]"
                :error-messages="errors('email')"
                @input="clearErrors"
              />
              <v-label>
                Ваш e-mail будет использован для входа, для воcстановления
                пароля. Другие участники не увидят его. Если введете не свой
                e-mail, то не сможете войти.
              </v-label>
              <v-text-field
                label="Ник"
                v-model="shortName"
                required
                id="short-name"
                :rules="[validation.fieldIsRequired]"
                :error-messages="errors('shortName')"
                @input="clearErrors"
              />
              <v-label>
                Ваш ник будет виден другим пользователям в рейтингах и т.п.
              </v-label>
              <v-text-field
                label="Полное имя"
                v-model="fullName"
                required
                id="full-name"
                :rules="[validation.fieldIsRequired]"
                :error-messages="errors('fullName')"
                @input="clearErrors"
              />
              <v-label>
                Ваше имя НЕ будет видно другим пользователям
              </v-label>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              block
              dark
              class="primary"
              @click="doRegister"
              id="registerButton"
            >
              Регистрация
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { store } from '../lib/Utils'
import validation from '../lib/Validation'
import { mapMutations, mapActions } from 'vuex'
export default {
  name: 'Register',
  data() {
    return {
      email: '',
      shortName: '',
      fullName: '',
      valid: false,
      validation,
      errorsData: []
    }
  },
  methods: {
    doRegister() {
      this.$refs.form.validate()
      if (this.valid) {
        this.request({
          url: 'auth/register',
          method: 'post',
          data: {
            email: this.email,
            shortName: this.shortName,
            fullName: this.fullName
          }
        })
          .then(() => {
            store('last-username', this.email)
            this.$router.push({ name: 'login' })
          })
          .catch(error => {
            this.errorsData = error.response.data.errors
          })
      } else {
        this.message({
          text: 'Пожалуйста устраните замечания в регистрационной форме',
          color: 'error'
        })
      }
    },
    clearErrors() {
      this.errorsData = []
    },
    errors(field) {
      if (Array.isArray(this.errorsData)) {
        return this.errorsData
          .filter(e => {
            return e.field === field
          })
          .map(e => {
            return e.message || e.error
          })
      }
    },
    ...mapMutations(['message']),
    ...mapActions(['request', 'login'])
  }
}
</script>
